import React from 'react';
import LoginButton from './login-button';

const PublicPage = () => {
    return (
        <div className='login_top'>
            <h2> Login Page (Administrator Only)</h2>

            <LoginButton/>
        </div>
    );
};

export default PublicPage;